import { Box, Divider, Stack } from '@mui/material'
import { FlutterLog } from './logsPage'
import { Typography } from '@eventr/common-storybook'
import { signal } from '@preact/signals-core'

interface ILogCardProps {
    log: FlutterLog
}
export const logDrawerDataSignal = signal<FlutterLog | null>(null)
export const logDrawerOpenSignal = signal<boolean>(false)
export const getLogMessage = (log?: FlutterLog) => {
    if (!log) return ''
    if (typeof log?.message === 'string') return log?.message
    return JSON.stringify(log?.message)
}
export const LogCard = ({ log }: ILogCardProps) => {
    const date = new Date(log.timeStamp)
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const seconds = date.getSeconds()
    const milliseconds = date.getMilliseconds()

    return (
        <Box
            onClick={() => {
                logDrawerOpenSignal.value = true
                logDrawerDataSignal.value = log
            }}
        >
            <Stack width={'100%'}>
                <Stack justifyContent={'space-between'} direction={'row'}>
                    <Typography variant="bodySubtext">{`${hours}:${minutes}:${seconds}:${milliseconds}`}</Typography>
                    <Stack direction={'row'} spacing={'5px'}>
                        {log.tags.map((t, i) => {
                            return (
                                <Typography
                                    key={i}
                                    variant="bodySubtext"
                                    children={t}
                                />
                            )
                        })}
                    </Stack>
                </Stack>
                <Typography
                    sx={{
                        lineBreak: 'anywhere',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                    }}
                >
                    {getLogMessage(log)}
                </Typography>
            </Stack>
            <Divider />
        </Box>
    )
}
